import { render, staticRenderFns } from "./AccountsTabs.vue?vue&type=template&id=5e370928&"
import script from "./AccountsTabs.vue?vue&type=script&lang=js&"
export * from "./AccountsTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports